import React, { useRef } from 'react'
import styled from 'styled-components'

import Modal from '@ntuctech/devex-tangram/Modal'
import ModalContent from '@ntuctech/devex-tangram/ModalContent'
import ModalActions from '@ntuctech/devex-tangram/ModalActions'
import Typography from '@ntuctech/devex-tangram/Typography'
import ButtonContained from '@ntuctech/devex-tangram/Button/ButtonContained'

const TypographySc = styled(Typography)`
  padding: 1.5rem 0;
  font-size: 1.25rem;
  font-weight: bold;
  color: #333333;
`

const ButtonSc = styled(ButtonContained)`
  width: 100%;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
`

const WelcomePopup = ({ handleWelcomePopup }) => {
  const ref = useRef(null)
  React.useEffect(() => {
    import('@lottiefiles/lottie-player')
  }, [])

  return (
    <Modal open>
      <ModalContent>
        <lottie-player
          ref={ref}
          src="https://media.nedigital.sg/linkpass/files/f0c9c191-6468-4a9f-b647-f02c0c788292/Main_Scene_edited.json"
          background="transparent"
          speed="1"
          loop
          autoplay
          mode="normal"
        ></lottie-player>
      </ModalContent>
      <TypographySc>Your account is created successfully!</TypographySc>
      <ModalActions>
        <ButtonSc onClick={handleWelcomePopup} data-testid="get_started_button">
          Get started
        </ButtonSc>
      </ModalActions>
    </Modal>
  )
}

export default WelcomePopup
